export enum ETipoOperacaoVendaDireta {
  VENDA_MERCADO_INTERNO = 'Venda no Mercado Interno',
  EXPORTACAO_INDIRETA = 'Exportação Indireta',
  EXPORTACAO_DIRETA = 'Exportação Direta',
}

interface TipoOperacaoVendaDiretaInfo {
  nome: string;
  indice: number;
  label: string;
}

export const TipoOperacaoVendaDiretaDetalhe: { [key in ETipoOperacaoVendaDireta]: TipoOperacaoVendaDiretaInfo } = {
  [ETipoOperacaoVendaDireta.VENDA_MERCADO_INTERNO]: {
    nome: 'VENDA_MERCADO_INTERNO',
    indice: 0,
    label: 'Venda no Mercado Interno',
  },
  [ETipoOperacaoVendaDireta.EXPORTACAO_INDIRETA]: {
    nome: 'EXPORTACAO_INDIRETA',
    indice: 1,
    label: 'Exportação Indireta',
  },
  [ETipoOperacaoVendaDireta.EXPORTACAO_DIRETA]: {
    nome: 'EXPORTACAO_DIRETA',
    indice: 2,
    label: 'Exportação Direta',
  },
};

export function getValueFromETipoOperacaoVendaDiretaByIndex(index: number) {
  const labels = Object.values(ETipoOperacaoVendaDireta);
  return labels[index];
}
